import { render } from "./MdlNuevaPartidaSalida.vue?vue&type=template&id=2888c758"
import script from "./MdlNuevaPartidaSalida.vue?vue&type=script&lang=js"
export * from "./MdlNuevaPartidaSalida.vue?vue&type=script&lang=js"

import "./MdlNuevaPartidaSalida.vue?vue&type=style&index=0&id=2888c758&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__